import { BaseService } from './BaseService';

export interface TestCompareResponse {
    result: string;
    reasoning: string;
}

export class TestService extends BaseService {
    compare = async (expected: string, actual: string, accessToken: string): Promise<TestCompareResponse> => {
        return await this.getResponseAsync<TestCompareResponse>(
            {
                commandPath: `test/compare`,
                method: 'POST',
                body: {
                    expected,
                    actual,
                },
            },
            accessToken,
        );
    };
}
